import { render, staticRenderFns } from "./DepositHistoryTab.vue?vue&type=template&id=0625ed40"
import script from "./DepositHistoryTab.vue?vue&type=script&lang=js"
export * from "./DepositHistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports